define([
    'text!WebCommon/component/page-header2024.html',
    'jquery',
    'WebCommon/mixin/headroom',
    'WebCommon/mixin/page-ready',
    'WebCommon/mixin/auth',
    'WebCommon/modal/modal',
    'WebCommon/utils',
    'WebCommon/api',
    'web/site/index2021/common/api',
    'lodash',
    'WebCommon/component/sub-nav',
    'web/shop/furniture-list-new2024/common/api',

    // 'css!web/static/fonts/fangzheng.css',
    'css!WebCommon/component/page-header2024.css'
], function(
    tpl,
    $,
    HeadroomMixin,
    PageReadyMixin,
    AuthMixin,
    Modal,
    Utils,
    Api,
    Api2020,
    _,
    SubNav,
    Newapi
){
    var topBarLinks = [
        {name: '上海客厅预约', class: 'sh-appoint'},

        {name: '实体店', link: '/shop'},
        // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
        {name: '商业合作', link: '/site/cooperate'}
    ];
    var navMenu = [
        {name: '首页', link: '/', menu: []},
        {name: '家具', link: '/furniture?tab=all',category: '1'},
        {name: '家居', link: '/grocery?tab=all',category: '2'},
        {name: '艺术/栏目', link: '/gallery'},
        // {name: '栏目', link: '/home'},
        {name: '新事', link: '/fnjinews', menu: []}
    ];
    return {
        template: tpl,
        mixins: [PageReadyMixin, AuthMixin, HeadroomMixin],
        components: {
            SubNav: SubNav
        },
        data: function(){
            return {
                searchText: '',
                searchShow: false,
                navMenu: [
                    {name: '首页', link: '/', children: []},
                    {name: '家具', link: '/furniture?tab=C09',category: '1', children: []},
                    {name: '家居', link: '/grocery?tab=G01',category: '2', children: []},
                    {name: '案例', link: '/caseNew', children: [
                            {name: '梵几在家',link: '/athome',type: 1},
                            {name: '商业',link: '/project',type: 2}
                        ]},
                    {name: '实体展厅', link: '/shops', children: [
                            {name: '北京·梵几三里屯太古里店',phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                            {name: '北京·梵几颐堤港店',phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                            {name: '北京·梵几客厅国子监店（升级中）',phoneTitle: '国子监店（升级中）',phoneName: '',link: '/exhibitionhall?id=4',type: 1},
                            {name: '上海·梵几上海前滩太古里店',phoneTitle: '上海',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                            {name: '上海·梵几客厅武康路店',phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                            {name: '广州·梵几广州粤海天地店',phoneTitle: '广州',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                            {name: '深圳·梵几万象前海店',phoneTitle: '深圳',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                            {name: '深圳·梵几卓越中心店',phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                            {name: '成都·梵几成都富森店',phoneTitle: '成都',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                            // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                            {name: '杭州·梵几留和路店',phoneTitle: '杭州',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                            {name: '苏州·梵几苏州诚品店',phoneTitle: '苏州',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                            // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                            {name: '南京·梵几南京金鹰世界店',phoneTitle: '南京',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                            {name: '西安·梵几西安万象城店',phoneTitle: '西安',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                        ]},
                    {name: '艺术/栏目', link: '/gallery', children: [
                            {name: '艺术展览·艺术橱窗·艺术快闪',link: '/gallery',type: 1,phoneChildren: [
                                    {name: '艺术展览',link: '/gallery'},
                                    {name: '艺术橱窗',link: '/gallery'},
                                    {name: '艺术快闪',link: '/gallery'}
                                ]},
                            {name: '串门',link: '/home-drop',type: 2}
                        ]},
                    // {name: '栏目', link: '/home'},
                    {name: '关于梵几', link: '/fnjinews', children: []},
                    {name: '下载区', link: '/download', children: [
                            {name: 'Sketchup&3dmax',link: '/download',type: 1},
                            {name: '产品册',link: '/catalog',type: 2},
                        ]},
                    {name: '如何购买', link: '/buyChannel', children: []}
                ],
                navMenuShopsPhone: [
                    {phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {phoneTitle: '',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                    {phoneTitle: '',phoneName: '国子监(升级中)',link: '/exhibitionhall?id=4',type: 1},
                    {phoneTitle: '上海',phoneName: '',link: '/exhibitionhall?id=5',type: 2},
                    {phoneTitle: '',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                    {phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                    {phoneTitle: '广州',phoneName: '',link: '/exhibitionhall?id=7',type: 3},
                    {phoneTitle: '',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                    {phoneTitle: '深圳',phoneName: '',link: '/exhibitionhall?id=8',type: 4},
                    {phoneTitle: '',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                    {phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                    {phoneTitle: '成都',phoneName: '',link: '/exhibitionhall?id=15',type: 5},
                    {phoneTitle: '',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                    {phoneTitle: '杭州',phoneName: '',link: '/exhibitionhall?id=11',type: 6},
                    {phoneTitle: '',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                    {phoneTitle: '苏州',phoneName: '',link: '/exhibitionhall?id=12',type: 7},
                    {phoneTitle: '',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                    {phoneTitle: '南京',phoneName: '',link: '/exhibitionhall?id=14',type: 8},
                    {phoneTitle: '',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                    {phoneTitle: '西安',phoneName: '',link: '/exhibitionhall?id=14',type: 9},
                    {phoneTitle: '',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                ],
                navMenuArt: [
                    {name: '艺术展览',link: '/gallery?tab=1'},
                    {name: '艺术橱窗',link: '/gallery?tab=2'},
                    {name: '艺术快闪',link: '/gallery?tab=3'},
                    {name: '串门',link: '/home-drop'}
                ],
                navMenuList: [],
                navMenuNewList: [],

                topBarLinks: [],
                headLeft: {},
                navMenuOffsetLeft: 903.5,
                // navMenuOffsetLeft: 200,
                newShow: true,
                isZh: true,

                menuShow: false,
                theMenu: 0,
                isPC: true,
                pageHeaderShow: true,
                scrollTimer: {},
                whitchTab: 100,
                memberId: ''
            };
        },
        methods: {
            toLogin: function(){
                window.location.href = "/loginnew";
            },
            Logout: function(){
                var _this = this;
                _this.memberId = '';
                localStorage.removeItem('fnjinew_memberId');
            },
            toSearch: function(){
                window.location.href = "/search";
            },
            init: function(){
                var _this = this;
                var zhOrEn = '';
                if(_this.$i18n.locale=='en'){
                    // _this.topBarLinks = _this.$i18n.messages.en.topBarLinks;
                    _this.headLeft = _this.$i18n.messages.en.headLeft;
                    _this.navMenu = _this.$i18n.messages.en.navMenu;
                    _this.$set(_this.navMenu,_this.navMenu);
                    zhOrEn = 'en';
                    _this.isZh = false;
                }else {
                    // _this.topBarLinks = _this.$i18n.messages.zh.topBarLinks;
                    _this.headLeft = _this.$i18n.messages.zh.headLeft;
                    _this.navMenu = _this.$i18n.messages.zh.navMenu;
                    _this.$set(_this.navMenu,_this.navMenu);
                    zhOrEn = 'zh';
                    _this.isZh = true;
                }
                if(_this.navMenuList.length){
                    // _this.navMenuList = _this.navMenu[_this.theMenu].menu;
                }
                if(_this.navMenuNewList.length){
                    // _this.navMenuNewList = _this.navMenu[_this.theMenu].newMenu;
                }
                if($(window).width()<755){
                    _this.isPC = false;
                }
                var memberid = localStorage.getItem('fnjinew_memberId');
                if(memberid){
                    _this.memberId = memberid;
                }
                Api2020.switchZhEnApi.ajax({language: zhOrEn})
                    .done(function(data){

                    });
                var pr = {
                    fnjiType: 1,
                    lang: ''
                };
                var pr2 = {
                    fnjiType: 2,
                    lang: ''
                };
                if(_this.$i18n.locale=='en'){
                    pr.lang = 'en';
                    pr2.lang = 'en';
                }
                Newapi.getFurnitureApi.ajax(pr)
                    .done(function(data){
                        console.log(data);
                        for(var i=0;i<data.length;i++){
                            _this.navMenu[1].children.push({name: data[i].name,link: '/furniture?tab='+data[i].value})
                        }
                    });
                Newapi.getFurnitureApi.ajax(pr2)
                    .done(function(data){
                        console.log(data);
                        for(var i=0;i<data.length;i++){
                            _this.navMenu[2].children.push({name: data[i].name,link: '/grocery?tab='+data[i].value})
                        }
                    });
            },
            menuClick: function(index){
                var obj = this;
                if(index===1){
                    obj.menuShow = true;
                    $('.page-header-new-menu-one').css({width: '375px'});
                    $('.page-header-new-menu-list-first li').css({opacity: 1});
                }else {
                    obj.menuShow = false;
                    $('.page-header-new-menu-one').css({width: '0'});
                    $('.page-header-new-menu-two').css({width: '0',transform: 'translateX(0)',transition: 'all 0.5s'});
                    obj.navMenuNewList = [];
                    // $('.page-header-new-menu-list li').css({opacity: 0});
                }
            },
            menuItemOver: function(item,index){
                var obj = this;
                obj.theMenu = index;
                if(item.children.length){
                    obj.navMenuList = item.children;
                    // obj.navMenuNewList = item.newMenu;
                    $('.page-header-new-menu-two').css({width: '375px',transform: 'translateX(-375px)',transition: 'all 0.5s'});
                }else {
                    $('.page-header-new-menu-two').css({width: '375px',transform: 'translateX(0)',transition: 'all 0.5s'});
                }
            },
            changeType: function(type){
                localStorage.setItem('locale',type);
                this.$i18n.locale = type;
                console.log(this.$i18n.locale);
                this.init();
            },
            showFnjiWeixinModal: function(){
                Modal.showFnjiWeixinSrvModal();
            },
            search: function(){
                var obj = this;
                if(obj.searchText){
                    window.location.href = Utils.genPageLink('/search-shop?word='+this.searchText);
                }else {
                    obj.searchShow = !obj.searchShow;
                }
            },
            login: function(from){
                Modal.showMemberLoginModal(from);
            },
            register: function(){
                Modal.showMemberRegisterModal();
            },
            genPageLink: Utils.genPageLink,
            isLinkActive: function(link){
                if(link=='/'&&window.location.href=='http://fnji.com/'){
                    return true;
                }else if(link=='/'&&window.location.href!='http://fnji.com/') {
                    return false;
                }else {
                    var pathName = window.location.pathname+'?tab=all';
                    var fullLink = this.genPageLink(link);
                    return pathName.indexOf(fullLink) === 0;
                }
            },
            goNeedAuthPage: function(link){
                var fullLink = this.genPageLink(link);
                if (this.isLoggedIn){
                    window.location.href = fullLink;
                } else {
                    this.login(fullLink);
                }
            },
            initNavMenu: function(){
                var _this = this;
                _.forEach(this.navMenu, function(o){
                    if (o.category){
                        Api.getMenuByCategoryApi.ajax({category: o.category})
                            .done(function(data){
                                o.menu = _.map(data, function(obj){
                                    obj.name = obj.descriptionM;
                                    obj.link = _this.genL2Link(o.category, obj.bom);
                                    return obj;
                                });
                            });
                    }
                });
            },
            updateNavMenuOffsetLeft: function(index)
            {
                var _this = this;
                var $target = $(_this.$refs.menuNavItem[index]);
                console.log($target);
                if(index===1||index===2){
                    _this.navMenuOffsetLeft = 100;
                }else if(index===3){
                    if(_this.isZh){
                        _this.navMenuOffsetLeft = 405;
                    }else {
                        _this.navMenuOffsetLeft = 520;
                    }
                }else if(index===4){
                    if(_this.isZh){
                        _this.navMenuOffsetLeft = 500;
                    }else {
                        _this.navMenuOffsetLeft = 600;
                    }
                }
            },
            getCategoryName: function(category){
                switch(category){
                    case 1:
                        return '';
                    case 2:
                        return '';
                    default:
                        return '';
                }
            },
            genL2Link: function(category, bom){
                var categoryName = this.getCategoryName(category);
                if (!categoryName) return '';
                return '/'+categoryName+'-l2?bom='+bom;
            },
            run: function() {
                // var num = 0;
                // var _this = this;
                // var i = setInterval(function () {
                //     if($(document).scrollTop()==0) {
                //         if (num < 40) {
                //             _this.newShow = false;
                //             // console.log(_this.newShow);
                //             num++;
                //         }
                //     }else {
                //         num = 40;
                //         _this.newShow = true;
                //     }
                // },300);
                // if($(document).scrollTop()!=0) {
                //     window.clearInterval(i);
                //     _this.newShow = true;
                // }
            }
        },
        mounted: function() {
            this.fetchMemberInfo();
            // this.initNavMenu();
            // this.run();
            // window.run = this.run;
            // isTop();
            this.init();
            // var obj = this;
            // $(window).scroll(function() {
            //     var pathname = window.location.pathname;
            //     if((pathname!='/buyChannel'&&pathname!='/gallery')||!obj.isPC){
            //         if(!obj.menuShow){
            //         }
            //     }
            // });
            // document.addEventListener("scroll", function(){
            //     clearTimeout(obj.scrollTimer);
            //     obj.scrollTimer = setTimeout(function() {
            //     }, 300);
            // });
        }
    };
    // function isTop() {
    //     $(document).scroll(function() {
    //         run()
    //     });
    // }
});



//////////////////
// WEBPACK FOOTER
// ../common/component/page-header2024.js
// module id = 26
// module chunks = 0 1 2 3